module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA3klEQVQ4jaXTQUoDQRBG4S8V8R4G3BjQO4iLSDxGQAU3uYjiwsVgcgzBRfAUieBG8BASGElwMT0yjgSS9i2bfn8X1VUdxZkWRxjhHAfp7B3PmOC1ebnTCNjHLa4R7dTEGo8YYwl7DfkJf8ppEbjEYaqwrF+620JucpqqFein1F25Qj9UDetmBHQxCgwy5JpBoPePgN6m79qWMlRDkstHqCYsl1lgilWGvMIkMEeREVBgXjdxjNkO8ktyfpamxBAPqoXZxDq9fJGcX1tX4gbHuMcbvvCJRTo7UY3wspa+AbGZK0JnBc6mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/li.png
// module id = RLF9
// module chunks = 1